/* Dachzelt-Quiz (sections/typeform-quiz.liquid): ersetzt den Typeform-Konfigurator */
(() => {
  const KLAVIYO_REVISION = '2026-07-15';
  const TRACKING_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'];
  const params = new URLSearchParams(location.search);
  const local = /^(localhost|127\.0\.0\.1)$/.test(location.hostname);
  // Lokale Vorschau, Theme-Editor und ?quiz_test=1: nichts an Klaviyo senden, nur in der Konsole ausgeben
  const testMode = params.has('quiz_test') || window.Shopify?.designMode || (local && !params.has('quiz_live'));

  // Für Customer Events (Custom Pixel), GTM über Stape und Microsoft Clarity
  const publish = (name, data) => {
    try {
      window.Shopify?.analytics?.publish?.(name, data);
    } catch (error) {
      console.warn('[Dachzelt-Quiz]', error);
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...data });
    if (typeof window.clarity === 'function') window.clarity('event', name);
  };

  const sendToKlaviyo = async (endpoint, publicKey, data) => {
    const response = await fetch(`https://a.klaviyo.com/client/${endpoint}?company_id=${encodeURIComponent(publicKey)}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: KLAVIYO_REVISION },
      body: JSON.stringify({ data }),
    });
    if (!response.ok) throw new Error(`Klaviyo ${endpoint}: HTTP ${response.status}`);
  };

  const init = (dialog) => {
    if (dialog.dataset.dzqReady) return;
    dialog.dataset.dzqReady = 'true';

    const steps = [...dialog.querySelectorAll('[data-dzq-step]')];
    const questions = steps.filter((step) => step.dataset.dzqStep === 'frage');
    const form = dialog.querySelector('form[data-dzq-step="email"]');
    const submit = form.querySelector('[type="submit"]');
    const error = form.querySelector('[data-dzq-error]');
    const back = dialog.querySelector('[data-dzq-back]');
    const progress = dialog.querySelector('.dzq__progress span');
    const progressSteps = questions.length + 1;
    // Kennungen aus snippets/quiz-dialog.liquid (Dachzelt- oder Markisen-Quiz)
    const prefix = dialog.dataset.eventPrefix || 'dachzelt_quiz';
    const quelle = dialog.dataset.quelle || 'Dachzelt-Quiz';
    const context = { quiz: dialog.dataset.quiz || 'dachzelt-konfigurator', seite: location.pathname };
    if (dialog.dataset.produkt) context.produkt = dialog.dataset.produkt;

    let current = 0;
    let answers = {};
    let done = false;
    let submissionId = null;

    dialog.querySelector('[data-dzq-test]').hidden = !testMode;

    const show = (index) => {
      current = index;
      steps.forEach((step, i) => {
        step.hidden = i !== index;
      });
      progress.style.width = `${(Math.min(index, progressSteps) / progressSteps) * 100}%`;
      back.hidden = index === 0 || done;
      const focusTarget = steps[index].querySelector('input[type="email"]') || steps[index].querySelector('.dzq__title');
      focusTarget?.focus({ preventScroll: true });
    };

    const reset = () => {
      answers = {};
      done = false;
      submissionId = null;
      dialog.querySelectorAll('.dzq__option').forEach((option) => option.setAttribute('aria-pressed', 'false'));
      form.reset();
      error.hidden = true;
      submit.disabled = false;
      show(0);
    };

    const showError = (message) => {
      error.textContent = message;
      error.hidden = false;
    };

    document.querySelectorAll(`[data-dzq-open="${dialog.id}"]`).forEach((button) => {
      button.addEventListener('click', () => {
        if (done) reset();
        dialog.showModal();
        show(current);
        publish(`${prefix}_geoeffnet`, context);
      });
    });

    questions.forEach((step, index) => {
      step.addEventListener('click', (event) => {
        const option = event.target.closest('.dzq__option');
        if (!option) return;
        step.querySelectorAll('.dzq__option').forEach((o) => o.setAttribute('aria-pressed', String(o === option)));
        answers[step.dataset.key] = option.dataset.value;
        publish(`${prefix}_antwort`, { ...context, frage: index + 1, feld: step.dataset.key, antwort: option.dataset.value });
        // kurz stehen lassen, damit die Auswahl sichtbar ist (wie bei Typeform)
        setTimeout(() => show(index + 1), 250);
      });
    });

    // Tasten A, B, C … wählen eine Antwort
    dialog.addEventListener('keydown', (event) => {
      const step = steps[current];
      if (step.dataset.dzqStep !== 'frage' || event.altKey || event.ctrlKey || event.metaKey) return;
      if (event.key.length !== 1) return;
      const option = step.querySelectorAll('.dzq__option')['abcdefghij'.indexOf(event.key.toLowerCase())];
      if (!option) return;
      event.preventDefault();
      option.click();
    });

    back.addEventListener('click', () => show(Math.max(0, current - 1)));
    dialog.querySelectorAll('[data-dzq-close]').forEach((button) => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('close', () => {
      if (!done && Object.keys(answers).length) publish(`${prefix}_abgebrochen`, { ...context, schritt: current + 1 });
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const email = form.elements.email.value.trim();
      if (!form.elements.email.checkValidity() || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        showError('Bitte gib eine gültige E-Mail-Adresse ein.');
        form.elements.email.focus();
        return;
      }
      if (questions.some((step) => !answers[step.dataset.key])) {
        showError('Bitte beantworte zuerst alle Fragen.');
        return;
      }
      error.hidden = true;
      submit.disabled = true;

      const { klaviyoKey, klaviyoEvent, klaviyoList } = dialog.dataset;
      const newsletter = Boolean(form.elements.newsletter?.checked);
      const tracking = Object.fromEntries(TRACKING_PARAMS.filter((key) => params.has(key)).map((key) => [key, params.get(key)]));
      // gleiche ID bei erneutem Absenden nach einem Fehler, damit Klaviyo das Event nicht doppelt zählt
      submissionId = submissionId || (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()));
      const profile = { type: 'profile', attributes: { email, properties: answers } };
      const requests = [
        [
          'events',
          {
            type: 'event',
            attributes: {
              unique_id: submissionId,
              properties: { ...answers, ...context, ...tracking, newsletter },
              metric: { data: { type: 'metric', attributes: { name: klaviyoEvent } } },
              profile: { data: profile },
            },
          },
        ],
      ];
      if (newsletter && klaviyoList) {
        requests.push([
          'subscriptions',
          {
            type: 'subscription',
            attributes: {
              custom_source: quelle,
              profile: {
                data: {
                  ...profile,
                  attributes: { ...profile.attributes, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } },
                },
              },
            },
            relationships: { list: { data: { type: 'list', id: klaviyoList } } },
          },
        ]);
      }

      try {
        if (testMode) {
          console.info(`[${quelle}] Testmodus, nichts an Klaviyo gesendet:`, requests);
        } else {
          await Promise.all(requests.map(([endpoint, data]) => sendToKlaviyo(endpoint, klaviyoKey, data)));
        }
      } catch (err) {
        console.error(`[${quelle}]`, err);
        showError('Das hat leider nicht geklappt. Bitte versuch es gleich nochmal.');
        submit.disabled = false;
        return;
      }

      done = true;
      publish(`${prefix}_abgeschickt`, { ...context, ...answers, newsletter });
      show(steps.length - 1);
    });
  };

  const initAll = (root) => root.querySelectorAll('dialog.dzq').forEach(init);
  initAll(document);
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
